import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Button from '../../../components/common/Button';
import formatCardNumber from '../../../utils/formatCardNumber';
import { cardNumberConfirm, cardNumberReject } from '../../registration/actions';
import contentStackImageUrls from '../../../../resources/contentStackImageUrls.json';

const { plusCard } = contentStackImageUrls;

export const ConfirmCardNumber = ({ cardNumber, reject, confirm }) => (
  <div className="modal confirm-card">
    <img
      src={plusCard}
      onError={(e) => { e.target.src = '../../../../assets/images/landing/plus-card.png'; }}
      className="confirm-card__image"
    />
    <h2 className="confirm-card__header">Confirm 16 Digit Card Number</h2>
    <h1 className="confirm-card__number">
      {formatCardNumber(cardNumber)}
    </h1>
    <p className="confirm-card__text">
      Confirm that the above 16 digit card number is correct.
    </p>
    <div className="modal__button-line">
      <Button
        className="modal__button button--secondary"
        onClick={reject}
      >
        Cancel
      </Button>
      <Button
        className="modal__button"
        onClick={confirm}
      >
        Continue
      </Button>
    </div>
  </div>
);

ConfirmCardNumber.propTypes = {
  cardNumber: PropTypes.string.isRequired,
  confirm: PropTypes.func.isRequired,
  reject: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  confirm: cardNumberConfirm,
  reject: cardNumberReject
};

export default connect(null, mapDispatchToProps)(ConfirmCardNumber);
